import { render, staticRenderFns } from "./center.vue?vue&type=template&id=1e467025&scoped=true"
import script from "./center.vue?vue&type=script&lang=js"
export * from "./center.vue?vue&type=script&lang=js"
import style0 from "./center.vue?vue&type=style&index=0&id=1e467025&prod&lang=scss&scoped=true"
import style1 from "./center.vue?vue&type=style&index=1&id=1e467025&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e467025",
  null
  
)

export default component.exports